import t from "./_flatten.js";
function e(e, f) {
  return t(e, f, !1);
}
export { e as default };